export default "__VITE_ASSET__BjelVVwm__"